import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { STATS } from "../data/products";
import { useLang } from "../i18n";
import { EASE, FadeIn, Micro } from "./Reveal";

function CountUp({ to, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10%" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: EASE,
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val}
      <span className="text-goldbright">{suffix}</span>
    </span>
  );
}

export default function Stats() {
  const { t } = useLang();
  const labels = t("stats.labels");
  return (
    <section data-testid="stats-section" className="border-t border-white/5 bg-gradient-to-b from-espresso/40 to-ink px-5 md:px-12 py-20 md:py-28">
      <FadeIn className="mb-12">
        <Micro className="text-gold/80">{t("stats.chapter")}</Micro>
      </FadeIn>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12">
        {STATS.map((s, i) => (
          <FadeIn key={s.label} delay={i * 0.08}>
            <div
              data-testid={`stat-${i}`}
              className={`text-center px-4 ${i > 0 ? "lg:border-l lg:border-white/10" : ""}`}
            >
              <div className="font-display text-5xl md:text-6xl text-gold">
                {s.text ? s.text : <CountUp to={s.value} suffix={s.suffix} />}
              </div>
              <div className="mt-3 text-[10px] md:text-xs tracking-[0.25em] uppercase text-cream/50">
                {labels[i] || s.label}
              </div>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
